// src/i18n/fr.js
// Traductions françaises - NE PAS MODIFIER

const fr = {
  // Navigation
  nav: {
    explorer: 'Explorer',
    favorites: 'Favoris',
    voyages: 'Voyages',
    messages: 'Messages',
    profile: 'Profil',
  },

  // Catégories
  categories: {
    sejours: 'Séjours',
    locations: 'Locations',
    immobilier: 'Immobilier',
    parcelles: 'Parcelles & Propriétés',
    services: 'Services',
  },

  // Descriptions de sections (accueil)
  sections: {
    sejoursTitle: 'Séjours courte durée',
    sejoursDesc: 'Hôtels, studios meublés et chambres',
    locationsTitle: 'Locations longue durée',
    locationsDesc: 'Appartements et maisons au mois',
    immobilierTitle: 'Parcelles & Propriétés',
    immobilierDesc: 'Terrains et biens à vendre',
    servicesTitle: 'Services',
    servicesDesc: 'Nettoyage, déménagement, rénovation',
    seeAll: 'Voir tout',
  },

  // Home
  home: {
    title: 'Fynho',
    recentTitle: 'Consultées récemment',
    recentDesc: 'Reprenez là où vous vous étiez arrêtés',
    heroTitlePart1: 'Trouvez votre',
    heroTitleHighlight: 'nouveau chez-vous',
    heroSubtitle: 'Séjours, locations, terrains et services partout au Cameroun.',
    searchPlaceholder: 'Recherchez un quartier...',
    useLocation: 'Rechercher à proximité',
    featured: 'Annonces à la une',
    viewMap: 'Carte',
    noResults: 'Aucun résultat trouvé',
    listing: 'annonce',
    listings: 'annonces',
    footerTagline: 'Find Your New Home',
  },

  // Listing
  listing: {
    price: 'Prix',
    bedroom: 'Chambre',
    bedrooms: 'Chambres',
    bathroom: 'Salle de bain',
    bathrooms: 'Salles de bain',
    area: 'Superficie',
    capacity: 'Capacité',
    person: 'personne',
    persons: 'personnes',
    perNight: 'par nuit',
    perMonth: 'par mois',
    perSquareMeter: 'par m²',
    amenities: 'Équipements',
    photos: 'Photos',
    description: 'Description',
    location: 'Localisation',
    contact: 'Contact',
    phone: 'Téléphone',
    whatsapp: 'WhatsApp',
    reserve: 'Réserver',
    addToFavorites: 'Ajouter aux favoris',
    removeFromFavorites: 'Retirer des favoris',
    share: 'Partager',
    report: 'Signaler',
    viewOnMap: 'Voir sur la carte',
    distance: 'à',
    distanceKm: 'km',
  },

  // Réservation
  reservation: {
    title: 'Demander une réservation',
    fullName: 'Nom complet',
    phone: 'Téléphone ou WhatsApp',
    email: 'Email',
    checkInDate: 'Date d\'arrivée',
    checkOutDate: 'Date de départ',
    numberOfGuests: 'Nombre de personnes',
    message: 'Message (optionnel)',
    submit: 'Envoyer la demande',
    success: 'Réservation envoyée avec succès!',
    error: 'Erreur lors de l\'envoi de la réservation',
    terms: 'J\'accepte les conditions d\'utilisation',
  },

  // Admin
  admin: {
    dashboard: 'Tableau de bord',
    listings: 'Annonces',
    reservations: 'Réservations',
    owners: 'Propriétaires',
    users: 'Utilisateurs',
    admins: 'Administrateurs',
    quartiers: 'Quartiers',
    types: 'Types d\'annonces',
    reviews: 'Avis',
    reports: 'Signalements',
    stats: 'Statistiques',
    auditLogs: 'Logs d\'audit',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    approve: 'Approuver',
    reject: 'Rejeter',
    view: 'Voir',
    actions: 'Actions',
    status: 'Statut',
  },

  // Statuts
  status: {
    draft: 'Brouillon',
    pending: 'En attente',
    published: 'Publié',
    rejected: 'Rejeté',
    disabled: 'Désactivé',
    new: 'Nouvelle demande',
    contacted: 'Contacté',
    confirmed: 'Confirmé',
    cancelled: 'Annulée',
    archived: 'Archivée',
  },

  // Messages communs
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Information',
    ok: 'OK',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    noData: 'Aucune donnée',
    tryAgain: 'Réessayer',
    language: 'Langue',
    theme: 'Thème',
    themeDark: 'Sombre',
    themeLight: 'Clair',
    settings: 'Paramètres',
    help: 'Aide',
    support: 'Support',
    logout: 'Déconnexion',
    all: 'Tout',
  },

  // Erreurs
  errors: {
    required: 'Ce champ est obligatoire',
    invalidEmail: 'Email invalide',
    invalidPhone: 'Numéro de téléphone invalide',
    minLength: 'Minimum {min} caractères',
    maxLength: 'Maximum {max} caractères',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    networkError: 'Erreur réseau. Vérifiez votre connexion.',
    serverError: 'Erreur serveur. Réessayez plus tard.',
    notFound: 'Ressource non trouvée.',
    unauthorized: 'Authentification échouée.',
    forbidden: 'Accès refusé.',
    validationError: 'Vérifiez les données saisies.',
  },

  // Quartiers (exemples)
  quartiers: {
    bonapriso: 'Bonapriso',
    bastos: 'Bastos',
    akwa: 'Akwa',
    bonanjo: 'Bonanjo',
    douala: 'Douala',
    yaounde: 'Yaoundé',
    bafoussam: 'Bafoussam',
    kumba: 'Kumba',
  },
};

export default fr;